export default __webpack_public_path__ + "static/media/onlinelearning.8e7484a6.jpg";